// @flow
/**
 * FileService
 *
 * @function
 * @namespace File
 * @version 1.0.0
 * @description
 * Service for operations on files
 *
 * @return { Object } Exposes `downloadFile`
 */

const downloadFile = (data: string, filename: string, fileType: string, downloadLink: Object) => {
  let file = null
  try {
    // Specify the filename using the File constructor
    file = new File([data], filename, { type: fileType })
  } catch (e) {
    console.log(e)
    // ... fall back to the Blob constructor if that isn't supported.
    file = new Blob([data], { type: fileType })
  }
  let url = URL.createObjectURL(file)
  let link = downloadLink
  link.href = url
  link.setAttribute('download', filename)
  link.click()
}

const addDropFileFunctionalityToDroptarget = (droptarget: Object, dropFunction: Function) => {
  ;['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(evt => {
    droptarget.addEventListener(evt, e => {
      e.preventDefault()
      e.stopPropagation()
    })
  })

  droptarget.addEventListener('drop', dropFunction)
}
const self = {
  downloadFile,
  addDropFileFunctionalityToDroptarget
}

/**
 * File service: Service for operations on files
 * @module FileService
 * @namespace FileService
 * @version 1.0.0
 */
export default self
